import { Box, Tooltip } from "@mui/material";
import React, { useRef, useState } from "react";

interface TruncatedTextProps {
  text?: string | null;
  maxWidth?: number;
}

// Cuts long values (e.g. MNC lists) to one short line; the tooltip with the
// full value only opens when the text is actually cut off.
const TruncatedText: React.FC<TruncatedTextProps> = ({
  text,
  maxWidth = 120,
}) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [open, setOpen] = useState(false);

  if (!text) return <>-</>;

  return (
    <Tooltip
      title={text}
      placement="top"
      arrow
      open={open}
      onOpen={() => {
        const el = textRef.current;
        if (el && el.scrollWidth > el.clientWidth) setOpen(true);
      }}
      onClose={() => setOpen(false)}
    >
      <Box
        ref={textRef}
        component="span"
        sx={{
          display: "block",
          maxWidth,
          mx: "auto",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          cursor: "default",
        }}
      >
        {text}
      </Box>
    </Tooltip>
  );
};

export default TruncatedText;
